import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { requestFlagMemberAsPaid } from '../../../api/external-registration/external-registration.actions';

import RegistrationSuccess from '../../../components/screens/auth/registration-success/RegistrationSuccess';

const RegistrationSuccessContainer = (): ReactElement => {
  const { programmeExternalReference, memberExternalReference } = useParams();

  const dispatch: Dispatch = useDispatch();

  useEffect((): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to external registration actions
      requestFlagMemberAsPaid({
        memberExternalReference,
        programmeExternalReference
      })
    );
  }, [dispatch, programmeExternalReference, memberExternalReference]);

  return <RegistrationSuccess />;
};

export default RegistrationSuccessContainer;
